// extracted by mini-css-extract-plugin
export default {"markerPfp":"CustomMarker_markerPfp__gyuqZ","username":"CustomMarker_username__t7azj","ip":"CustomMarker_ip__Mgxnd","historicalMarker":"CustomMarker_historicalMarker__tTVx4"};